<form #diningRoomsDecisionForm="ngForm" *ngIf="decision" class="decisionContent">
    <kiwi-decision-header
        (saved)="save()"
        [title]="'decisions.dining.rooms.dining.rooms.managing'|translate" [i18nKey]="[{target: 'attribute:title', key: 'decisions.dining.rooms.dining.rooms.managing'}]"
        [decisionIsInvalid]="diningRoomsDecisionForm.invalid">
    </kiwi-decision-header>

    <kiwi-spacer [size]="32"></kiwi-spacer>

    <!-- Main block containing the decision -->
    <kiwi-decision-content (saved)="save()" class="diningRoomsContent">
        <div class="cell auto diningRoomsContent-container">
            <div class="grid-x grid-margin-x grid-margin-y align-center">
                <div class="cell xsmall-24 large-18 xlarge-16 xxlarge-14 grid-x grid-margin-x grid-margin-y">
                    <fieldset class="cell xsmall-24">
                        <legend [i18nKey]="'decisions.dining.rooms.dining.rooms.managing'"></legend>

                        <table class="_tableColor">
                            <tbody>
                            <tr class="_titlePartTable">
                                <td class="_number"[i18nKey]="'decisions.dining.rooms.dining.rooms.current.rooms.number'"></td>
                                <td class="_number"[i18nKey]="'decisions.dining.rooms.dining.rooms.new.rooms.number'"></td>
                                <td class="_number"[i18nKey]="'decisions.dining.rooms.dining.rooms.rent.per.room'"></td>
                                <td class="_number"[i18nKey]="'decisions.dining.rooms.dining.rooms.total.rent'"></td>
                                <td class="_number"[i18nKey]="'decisions.dining.rooms.dining.rooms.seating.per.room'"></td>
                                <td class="_number"[i18nKey]="'decisions.dining.rooms.dining.rooms.seating.total'"></td>
                            </tr>

                            <tr>
                                <td class="_number">
                                    {{parameters.previousPeriodDiningRoomsDecision.roomsNumber}}
                                </td>
                                <td class="_number">
                                    <input [(ngModel)]="decision.roomsNumber"
                                           type="number"
                                           (ngModelChange)="onRoomsNumberUpdate()"
                                           name="roomsNumber"
                                           [disabled]="decisionsReadonly"/>
                                </td>
                                <td class="_number">
                                    {{areaMonthlyRent | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
                                </td>
                                <td class="_number">
                                    {{areaMonthlyRent * decision.roomsNumber | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
                                </td>
                                <td class="_number">
                                    {{parameters.diningRoomsParameters.diningRoomSeatingCapacity | number:'1.0'}}
                                </td>
                                <td class="_number">
                                    {{parameters.diningRoomsParameters.diningRoomSeatingCapacity * decision.roomsNumber | number:'1.0'}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </fieldset>

                    <fieldset class="cell xsmall-24">
                        <legend [i18nKey]="'decisions.dining.rooms.maintenance.management'"></legend>

                        <table class="_tableColor">
                            <tbody>
                            <tr class="_titlePartTable">
                                <td class="_number"[i18nKey]="'decisions.dining.rooms.maintenance.current.budget.per.room'"></td>
                                <td class="_number"[i18nKey]="'decisions.dining.rooms.maintenance.new.budget.per.room'"></td>
                                <td class="_number"[i18nKey]="'decisions.dining.rooms.maintenance.current.total.budget'"></td>
                                <td class="_number"[i18nKey]="'decisions.dining.rooms.maintenance.new.total.budget'"></td>
                            </tr>

                            <tr>
                                <td class="_number">
                                    {{parameters.previousPeriodDiningRoomsDecision.maintenanceDecision.maintenanceBudgetPerRoom | number:'1.2'}}
                                    <span [i18nKey]="'common.change.euros'"></span>
                                </td>
                                <td class="_number">
                                    <kiwi-currency-input
                                        [(ngModel)]="decision.maintenanceDecision.maintenanceBudgetPerRoom"
                                        (ngModelChange)="onMaintenanceBudgetPerRoomChange()"
                                        [disabled]="decisionsReadonly"
                                        name="maintenanceBudgetPerRoom">
                                    </kiwi-currency-input>
                                </td>
                                <td class="_number">
                                    {{(parameters.previousPeriodDiningRoomsDecision.maintenanceDecision.maintenanceBudgetPerRoom *
                                    parameters.previousPeriodDiningRoomsDecision.roomsNumber) | number:'1.2'}}
                                    <span [i18nKey]="'common.change.euros'"></span>
                                </td>
                                <td class="_number">
                                    {{decision.maintenanceDecision.maintenanceBudgetPerRoom * decision.roomsNumber | number:'1.2'}}
                                    <span [i18nKey]="'common.change.euros'"></span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </fieldset>

                    <fieldset class="cell xsmall-24">
                        <legend [i18nKey]="'decisions.dining.rooms.layout.management'"></legend>

                        <table class="_tableColor">
                            <tbody>
                            <tr class="_titlePartTable">
                                <td></td>
                                <td class="_number"[i18nKey]="'decisions.dining.rooms.layout.management.current.quality'"></td>
                                <td class="_number"[i18nKey]="'decisions.dining.rooms.layout.management.quality.wanted'"></td>
                                <td class="_number"[i18nKey]="'decisions.dining.rooms.layout.management.current.value.per.room'"></td>
                                <td class="_number"[i18nKey]="'decisions.dining.rooms.layout.management.value.per.room.wanted'"></td>
                            </tr>

                            <tr>
                                <td [i18nKey]="'decisions.dining.rooms.furniture'"></td>
                                <td class="_number">{{decision.layoutDecision.furniture.currentQuality}}</td>
                                <td class="_number">
                                    <input [(ngModel)]="decision.layoutDecision.furniture.newQuality"
                                           type="number"
                                           (ngModelChange)="updateFurnitureCurrentQuality()"
                                           name="newFurnitureQuality"
                                           step="0.01"
                                           [disabled]="decisionsReadonly"/>
                                </td>
                                <td class="_number">
                                    {{decision.layoutDecision.furniture.currentValuePerRoom | number:'1.2'}}
                                    <span [i18nKey]="'common.change.euros'"></span>
                                </td>
                                <td class="_number">{{decision.layoutDecision.furniture.newValuePerRoom | number:'1.2'}}
                                    <span [i18nKey]="'common.change.euros'"></span></td>
                            </tr>

                            <tr>
                                <td [i18nKey]="'decisions.dining.rooms.tableware'"></td>
                                <td class="_number">{{decision.layoutDecision.tableware.currentQuality}}</td>
                                <td class="_number">
                                    <input [(ngModel)]="decision.layoutDecision.tableware.newQuality"
                                           type="number"
                                           (ngModelChange)="updateTablewareCurrentQuality()"
                                           name="newTablewareQuality"
                                           step="0.01"
                                           [disabled]="decisionsReadonly"/>
                                </td>
                                <td class="_number">
                                    {{decision.layoutDecision.tableware.currentValuePerRoom | number:'1.2'}}
                                    <span [i18nKey]="'common.change.euros'"></span>
                                </td>
                                <td class="_number">{{decision.layoutDecision.tableware.newValuePerRoom | number:'1.2'}}
                                    <span [i18nKey]="'common.change.euros'"></span></td>
                            </tr>
                            </tbody>
                        </table>
                    </fieldset>

                    <fieldset class="cell xsmall-24">
                        <legend [i18nKey]="'decisions.dining.rooms.layout.purchase.and.selling'"></legend>

                        <table class="_tableColor">
                            <tbody>
                            <tr class="_titlePartTable">
                                <td></td>
                                <td class="_number"[i18nKey]="'decisions.dining.rooms.layout.purchase.cost.per.room'"></td>
                                <td class="_number"[i18nKey]="'decisions.dining.rooms.layout.total.purchase.cost'"></td>
                                <td class="_number"[i18nKey]="'decisions.dining.rooms.layout.total.selling.income'"></td>
                            </tr>
                            <tr>
                                <td [i18nKey]="'decisions.dining.rooms.furniture'"></td>
                                <td class="_number">
                                    {{(totalFurniturePurchaseCost > 0 ? decision.layoutDecision.furniture.newValuePerRoom : 0) | number:'1.2'}}
                                    <span [i18nKey]="'common.change.euros'"></span>
                                </td>
                                <td class="_number">
                                    {{totalFurniturePurchaseCost | number:'1.2'}}
                                    <span [i18nKey]="'common.change.euros'"></span>
                                </td>
                                <td class="_number">
                                    {{totalFurnitureSellingIncome | number:'1.2'}}
                                    <span [i18nKey]="'common.change.euros'"></span>
                                </td>
                            </tr>
                            <tr>
                                <td [i18nKey]="'decisions.dining.rooms.tableware'"></td>
                                <td class="_number">
                                    {{(totalTablewarePurchaseCost > 0 ? decision.layoutDecision.tableware.newValuePerRoom : 0) | number:'1.2'}}
                                    <span [i18nKey]="'common.change.euros'"></span>
                                </td>
                                <td class="_number">
                                    {{totalTablewarePurchaseCost | number:'1.2'}}
                                    <span [i18nKey]="'common.change.euros'"></span>
                                </td>
                                <td class="_number">
                                    {{totalTablewareSellingIncome | number:'1.2'}}
                                    <span [i18nKey]="'common.change.euros'"></span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </fieldset>
                </div>

                <div class="cell xsmall-24 large-6 xlarge-8 xxlarge-10">
                    <kiwi-spacer [size]="16"></kiwi-spacer>

                    <p [innerHTML]="'decisions.dining.rooms.explanation'|translate" [i18nKey]="[{target: 'innerHTML', key: 'decisions.dining.rooms.explanation'}]"></p>

                    <kiwi-score-image [imgQualityClass]="imgClass"
                                      [scores]="scores"
                                      [imgType]="'_diningRooms'">
                    </kiwi-score-image>
                </div>
            </div>
        </div>
    </kiwi-decision-content>
</form>
